export default __webpack_public_path__ + "static/media/giftcard.84c6c2db.png";